/* eslint-disable */
/**
 * iview按需加载
 */
 import {
  Button,
  Table,
  Layout,
  Sider,
  Header,
  Menu,
  MenuGroup,
  Icon,
  MenuItem,
  Submenu,
  Dropdown,
  Avatar,
  DropdownMenu,
  DropdownItem,
  Badge,
  Input,
  Tag,
  Form,
  FormItem,
  Select,
  Page,
  Message,
  LoadingBar,
  Modal,
  Notice,
  Spin,
  Checkbox,
  CheckboxGroup,
  Option,
  ButtonGroup,
  ColorPicker,
  Col,
  Row,
  DatePicker,
  Tree,
  Radio,
  RadioGroup,
  Upload,
  Progress,
  TimePicker,
  Tabs,
  TabPane,
  Switch
} from 'view-design';
import Sicon from '../components/Sicon.vue'
const components = {
  iInput: Input,
  Row,
  iButton: Button,
  DatePicker,
  TimePicker,
  iCol: Col,
  iForm: Form,
  iSelect: Select,
  iOption: Option,
  Button,
  Layout,
  Sider,
  Header,
  Menu,
  MenuGroup,
  Icon,
  MenuItem,
  Submenu,
  Dropdown,
  Avatar,
  DropdownMenu,
  DropdownItem,
  Badge,
  Sicon,
  Input,
  Tag,
  Form,
  FormItem,
  Select,
  Table,
  Page,
  LoadingBar,
  Message,
  Modal,
  Notice,
  Spin,
  Checkbox,
  CheckboxGroup,
  Option,
  ButtonGroup,
  ColorPicker,
  Tree,
  Radio,
  RadioGroup,
  Upload,
  Progress,
  Tabs,
  TabPane,
  iSwitch:Switch
}
export default {
  install(Vue, opts = {}) {
    Vue.prototype.$Loading = LoadingBar;
    Vue.prototype.$Message = Message;
    Vue.prototype.$Modal = Modal;
    Vue.prototype.$Notice = Notice;
    Vue.prototype.$Spin = Spin;
    Vue.prototype.$Loading.config({
      color: '#2d8cf0',
      failedColor: '#f0ad4e',
    });
    Object.keys(components).forEach(key => {
      Vue.component(key, components[key]);
    });
  }
}